<template>
  <v-navigation-drawer v-model="chat" absolute temporary right width="25%">
    <div class="chat-wrapper d-flex flex-column grey lighten-4 pa-5" id="chat-wrapper">
      <div class="text-h6 mb-4 text-center">{{ $t('messages') }}</div>

      <div class="questions-wrapper" ref="questionsWrapper">
        <div
          class="d-flex flex-column"
          v-for="(question, index) in questions"
          :key="index"
        >
          <div class="body-1 mr-2 submitted-message" v-html="linkifiedMessage(question.question)"></div>

          <v-divider class="my-2"></v-divider>
        </div>
      </div>

      <v-textarea
        outlined
        hide-details
        class="mt-auto flex-grow-0 chat-textarea"
        color="primary"
        append-icon="mdi-send"
        v-model="question"
        @click:append="onSendQuestion"
        @keyup.enter.exact.prevent="onSendQuestion"
        autocomplete="off"
        :loading="loader"
        auto-grow
        rows="1"        
      ></v-textarea>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      question: "",
      loader: false,
    };
  },
  computed: {
    chat: {
      get() {
        return this.$store.state.base.chat;
      },
      set(value) {
        if (!value) this.toggleChat(value);
      },
    },
    ...mapState({
      questions: (state) => state.school.questions,
    }),
  },
  methods: {
    ...mapMutations(["toggleChat"]),
    ...mapActions(["sendQuestion"]),
    linkifiedMessage(question) {
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      return question.replace(urlRegex, (url) => {
        return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
      });
    },
    async onSendQuestion() {
      if (!this.question) return;

      this.loader = true;

      try {
        await this.sendQuestion(this.question);

        this.loader = false;
        this.$vuetify.goTo(this.$refs.questionsWrapper.clientHeight, {
          container: ".questions-wrapper",
        });
      } catch (e) {
        console.log(e);
        this.loader = false;
      }

      this.question = "";
    },
  },
  watch: {
    chat(newValue) {
      if (newValue) {
        this.$vuetify.goTo(this.$refs.questionsWrapper.clientHeight, {
          container: ".questions-wrapper",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .chat-wrapper {
    height: 100%;
  }

  .questions-wrapper {
    flex: 1 0 auto;
    overflow-y: auto;
    height: 0px;
  }

  .submitted-message {
    word-break: break-all;
  }
</style>

<style>
  #chat-wrapper .chat-textarea textarea {
    max-height: 120px; /* ~5 lines (adjust based on your font/line-height) */
    overflow-y: auto;
    scrollbar-width: thin;
    margin-top: 0;
  }

  #chat-wrapper .chat-textarea .v-text-field__slot {
    padding: 8px;
  }

  #chat-wrapper .chat-textarea .v-input__append-inner {
    padding-left: 18px;
    margin-top: 0;
    align-self: center;
  }
</style>